<div class="ws-page ws-page-spacious">
  <header class="page-head">
    <div>
      <p class="kicker">Compliance · Rule-check history</p>
      <div class="page-head-title-row">
        <app-page-back-btn />
        <h2>Rule-check history</h2>
        <app-page-refresh-btn [loading]="loading()" (refresh)="reload()" />
      </div>
      <p class="muted ws-lead">Latest bye-law result per plot — expand a row for rule detail.</p>
    </div>
  </header>

  <p class="error" *ngIf="error()">{{ error() }}</p>

  <section class="page-card page-card--compact-head">
    <h3 class="panel-title">Compliance runs</h3>
    <p class="ws-loading" *ngIf="loading()">Loading rule-check history…</p>
    <p class="ws-empty" *ngIf="!loading() && !historyRows().length">
      No rule-check runs recorded yet. Run a rule check from Measurements after finalising measurements.
    </p>

    <div class="table-wrap" *ngIf="!loading() && historyRows().length">
      <table class="data compliance-runs-table">
        <thead>
          <tr>
            <th>Plot</th>
            <th>Result</th>
            <th>Rules</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let row of historyRows()">
            <tr [class.row-highlight]="isHighlighted(row)">
              <td class="col-plot">
                <strong class="plot-ref">{{ row.summaryOnly ? 'All plots' : ('Khasra ' + row.plotRef) }}</strong>
              </td>
              <td>
                <span class="rc-result" [ngClass]="resultClass(row)">{{ resultLabel(row) }}</span>
              </td>
              <td>
                <button
                  type="button"
                  class="btn secondary btn-compact"
                  *ngIf="canShowRules(row)"
                  (click)="toggleRules(row)"
                >
                  {{ isExpanded(row) ? 'Hide rules' : 'Show rules' }}
                </button>
                <span class="text-meta" *ngIf="!canShowRules(row)">—</span>
              </td>
              <td class="col-action">
                <a
                  *ngIf="row.flagId"
                  class="btn-action"
                  [routerLink]="['/enforcement/flags']"
                  [queryParams]="{ flagId: row.flagId }"
                >
                  View flag
                </a>
                <span class="text-meta" *ngIf="!row.flagId && row.compliant">—</span>
              </td>
            </tr>
            <tr class="rules-detail-row" *ngIf="isExpanded(row)">
              <td colspan="4">
                <div class="detail-expand-panel">
                  <dl class="detail-grid run-meta">
                    <div>
                      <dt>Run time</dt>
                      <dd>{{ (row.endedAt || row.startedAt) | date: 'medium' }}</dd>
                    </div>
                    <div>
                      <dt>Reference mode</dt>
                      <dd>{{ referenceLabel(row.referenceMode) }}</dd>
                    </div>
                  </dl>
                  <table class="data compact-table rc-rules-table" *ngIf="row.rules?.length">
                    <thead>
                      <tr>
                        <th>Rule</th>
                        <th>Status</th>
                        <th>Measured</th>
                        <th>Limit</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let rule of row.rules">
                        <td>
                          <strong [attr.title]="rule.ruleCode">{{ rule.ruleName || rule.ruleCode }}</strong>
                        </td>
                        <td>
                          <span class="rc-rule" [ngClass]="ruleStatusClass(rule.status)">{{ ruleStatusLabel(rule.status) }}</span>
                        </td>
                        <td class="num">{{ formatRuleValue(rule.measured, rule.unit) }}</td>
                        <td class="num">{{ formatRuleValue(rule.limit, rule.unit) }}</td>
                      </tr>
                    </tbody>
                  </table>
                  <p class="text-meta tolerance-note" *ngIf="row.rules?.length">
                    Tolerance values shown on hover in full audit export.
                  </p>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </section>
</div>
